import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Spinner from '@material-ui/core/CircularProgress';

import { Collapse } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import AlertTitle from '@material-ui/lab/AlertTitle';
import Button from '@material-ui/core/Button';
import { unregister } from "../Interceptor.js";

//para pruebas de Creacion de Factura
localStorage.setItem('nombreCliente', "Empresa S.A.S");
localStorage.setItem('tipoPersonaCliente', 1);
localStorage.setItem('regimenCliente', 1);
localStorage.setItem('tipoDocCliente', 5);
localStorage.setItem('numDocCliente', "900000000");
localStorage.setItem('dvCliente', "4");
localStorage.setItem('direccionCliente', "Calle 100 #23-23 Oficina 234 ");
localStorage.setItem('pais', 44);
localStorage.setItem('estado', 5);
localStorage.setItem('ciudad', 148);
localStorage.setItem('telefonoCliente', 2342343234);
localStorage.setItem('zipCliente', 110221);
localStorage.setItem('correoCliente', "empresaprueba@gmail.com");

var cont = 0;
var dataTiposPersona = [{}];
var dataTiposIdenPersona = [{}];
var dataPaises = [{}];
var dataDepartamentos = [{}];
var dataCiudades = [{}];
var dataRegimen = [{}];
var dataCliente = {};
var NombreCliente = "";
var tipoPersona = 0;
var regimen = 0;
var tipoIdent = 0;
var nit = "";
var dv = "";
var direccion = "";
var pais = 0;
var estado = 0;
var ciudad = 0;
var telefono = "";
var zip = "";
var correo = "";

export default function AddressForm() {

    const [loading, setLoading] = React.useState(false);

    const [alertaInfo, setalertaInfo] = React.useState(true);
    const [alertaError, setalertaError] = React.useState(false);
    const [alertaSuccess, setalertaSuccess] = React.useState(false);
    
    const selectDataLoad = () => {

        var myHeaders = new Headers();
       

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            redirect: 'follow'
        };

        fetch("./api/Auxiliar/ListaTiposPersona", requestOptions)
            .then(response => response.json())
            .then(result => {
                dataTiposPersona = result.basePresentationList;                
                setData(dataTiposPersona);
            })
            .catch(error => console.log('error', error));
    }
    const selectDataRegimenLoad = () => {

        var myHeaders = new Headers();

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            redirect: 'follow'
        };

        fetch("./api/Auxiliar/ListaRegimenesFiscales", requestOptions)
            .then(response => response.json())
            .then(result => {
                dataRegimen = result.basePresentationList;
                
                setRegimen(dataRegimen);
            })
            .catch(error => console.log('error', error));
    }
    const selectDataIdentLoad = () => {

        var myHeaders = new Headers();

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            redirect: 'follow'
        };

        fetch("./api/Auxiliar/ListaTiposIdentificacion", requestOptions)
            .then(response => response.json())
            .then(result => {
                dataTiposIdenPersona = result.basePresentationList;
                
                setDataIden(dataTiposIdenPersona);
            })
            .catch(error => console.log('error', error));
    }
    const selectDataPaisesLoad = () => {

        var myHeaders = new Headers();

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            redirect: 'follow'
        };

        fetch("./api/Auxiliar/ListaPaises", requestOptions)
            .then(response => response.json())
            .then(result => {
                dataPaises = result.basePresentationList;
                
                setDataPaises(dataPaises);
                setLoading(false);
            })
            .catch(error => console.log('error', error));
    }
    const selectDataDepartamentosLoad = (pais) => {

        var myHeaders = new Headers();

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            redirect: 'follow'
        };

        var url = "./api/Auxiliar/ListaDepartamentosPais?iIdPais=" + String(pais)

        fetch(url, requestOptions)
            .then(response => response.json())
            .then(result => {
                dataDepartamentos = result.basePresentationList;
                
                setDataDepts(dataDepartamentos);
            })
            .catch(error => console.log('error', error));
    }
    const selectDataCiudadesLoad = (ciudad) => {

        var myHeaders = new Headers();

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            redirect: 'follow'
        };

        var url = "./api/Auxiliar/ListaMuniciposDepartamento?iIdDepartamento=" + String(ciudad)

        fetch(url, requestOptions)
            .then(response => response.json())
            .then(result => {
                dataCiudades = result.basePresentationList;
                
                setDataCiudades(dataCiudades);
            })
            .catch(error => console.log('error', error));
    }
    const selectDataClienteLoad = () => {

        var myHeaders = new Headers();

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            redirect: 'follow'
        };

        var datafiscal = localStorage.getItem('datosEmpresaFiscales');
        var datosfis = JSON.parse(datafiscal);
        var idCliente = datosfis.IdCliente;

        var url = "/api/Cliente/TraerCliente?iIdCliente=" + String(idCliente);
        fetch(url, requestOptions)
            .then(response => response.json())
            .then(result => {
                dataCliente = result.basePresentation;
                NombreCliente = dataCliente.Nombre;
                localStorage.setItem('clienteDefault', dataCliente.Id);
                setNombre(NombreCliente);
                localStorage.setItem('nombreCliente', NombreCliente);
                tipoPersona = dataCliente.TipoPersona;
                setTipoPersona(tipoPersona);
                regimen = dataCliente.IdRegimenFiscal + 1;
                setRegimenData(regimen);
                tipoIdent = dataCliente.TipoIdentificacion;
                setTipoIdent(tipoIdent);
                nit = dataCliente.Nit;
                setNit(nit);

                dv = dataCliente.DigitoVerificacion;
                setdv(dv);
                direccion = dataCliente.Ubicacion;
                setdireccion(direccion);
                pais = dataCliente.IdPais;
                setpais(pais);
                estado = dataCliente.IdDepartamento;
                setestado(estado);
                selectDataCiudadesLoad(estado);
                ciudad = dataCliente.IdMunicipio;
                setciudad(ciudad);
                telefono = dataCliente.Telefono;
                settelefono(telefono);
                zip = dataCliente.CodigoPostal;
                setzip(zip);
                correo = dataCliente.Correo;
                setcorreo(correo);

                
                
                setDataCliente(dataCliente);
            })
            .catch(error => console.log('error', error));
    }


    const [nitbusqueda, setnitbusqueda] = React.useState("");
    const selectDataClienteFindLoad = () => {
        setalertaInfo(false);
        var myHeaders = new Headers();

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            redirect: 'follow'
        };

        var datafiscal = localStorage.getItem('datosEmpresaFiscales');
        var datosfis = JSON.parse(datafiscal);
        //var idCliente = datosfis.IdCliente;

        

        var url = "/api/Cliente/TraerClientexNit?NitCliente=" + String(nitbusqueda);
        fetch(url, requestOptions)
            .then(response => response.json())
            .then(result => {
                dataCliente = result.basePresentation;

                if (dataCliente == null) {
                    setalertaError(true);
                } else {
                    setalertaSuccess(true);

                    localStorage.setItem('clienteDefault', dataCliente.Id);

                    NombreCliente = dataCliente.Nombre;
                    setNombre(NombreCliente);
                    localStorage.setItem('nombreCliente', NombreCliente);
                    
                    tipoPersona = dataCliente.TipoPersona;
                    setTipoPersona(tipoPersona);
                    localStorage.setItem('tipoPersonaCliente', tipoPersona);

                    regimen = dataCliente.IdRegimenFiscal + 1;
                    setRegimenData(regimen);
                    localStorage.setItem('regimenCliente', regimen);

                    tipoIdent = dataCliente.TipoIdentificacion;
                    setTipoIdent(tipoIdent);
                    localStorage.setItem('tipoDocCliente', tipoIdent);

                    nit = dataCliente.Nit;
                    setNit(nit);
                    localStorage.setItem('numDocCliente', nit);

                    dv = dataCliente.DigitoVerificacion;
                    setdv(dv);
                    localStorage.setItem('dvCliente', dv);

                    direccion = dataCliente.Ubicacion;
                    setdireccion(direccion);
                    localStorage.setItem('direccionCliente', direccion);

                    pais = dataCliente.IdPais;
                    setpais(pais);
                    localStorage.setItem('pais', pais);

                    estado = dataCliente.IdDepartamento;
                    setestado(estado);
                    localStorage.setItem('estado', estado);

                    selectDataCiudadesLoad(estado);
                    ciudad = dataCliente.IdMunicipio;
                    setciudad(ciudad);
                    localStorage.setItem('ciudad', ciudad);

                    telefono = dataCliente.Telefono;
                    settelefono(telefono);
                    localStorage.setItem('telefonoCliente', telefono);

                    zip = dataCliente.CodigoPostal;
                    setzip(zip);
                    localStorage.setItem('zipCliente', zip);
                    correo = dataCliente.Correo;
                    setcorreo(correo);
                    localStorage.setItem('correoCliente', correo);

                    
                    
                    setDataCliente(dataCliente);
                }
            })
            .catch(error => console.log('error', error));
    }

    if (cont < 2) {
        selectDataLoad();
        selectDataIdentLoad();
        selectDataPaisesLoad();
        selectDataDepartamentosLoad(44);
        selectDataCiudadesLoad(5);
        selectDataRegimenLoad();
        selectDataClienteLoad();
        cont = cont + 1;
        
    }

    const [dataTiposPersonas, setData] = React.useState(dataTiposPersona);
    const [dataTipoRegimen, setRegimen] = React.useState(dataRegimen);
    const [dataTiposIdentificacionPersonas, setDataIden] = React.useState(dataTiposIdenPersona);
    const [dataPaisesLista, setDataPaises] = React.useState(dataPaises);
    const [dataDepartamentosLista, setDataDepts] = React.useState(dataDepartamentos);
    const [dataCiudadLista, setDataCiudades] = React.useState(dataCiudades);

    const [dataClienteLista, setDataCliente] = React.useState(dataCliente);
    const [nombreCliente, setNombre] = React.useState(NombreCliente);
    const [tipoPersonaData, setTipoPersona] = React.useState(tipoPersona);
    const [regimendata, setRegimenData] = React.useState(regimen);
    const [identidad, setTipoIdent] = React.useState(tipoIdent);
    const [nitcliente, setNit] = React.useState(tipoIdent);
    const [dvcliente, setdv] = React.useState(dv);
    const [direccioncliente, setdireccion] = React.useState(direccion);
    const [paiscliente, setpais] = React.useState(pais);
    const [estadocliente, setestado] = React.useState(estado);
    const [ciudadcliente, setciudad] = React.useState(ciudad);
    const [telefonocliente, settelefono] = React.useState(telefono);
    const [zipcliente, setzip] = React.useState(zip);
    const [correocliente, setcorreo] = React.useState(correo);

    //handle NombreCliente
    const handleNombreCliente = (selectedOption) => {
        localStorage.setItem('nombreCliente', selectedOption.target.value);
        
    }

    //handle Tipo Persona
    const handleTipoPersona = (selectedOption) => {
        localStorage.setItem('tipoPersonaCliente', selectedOption.target.value)
        
    };

    //handle Tipo Regimen
    const handleRegimen = (selectedOption) => {
        localStorage.setItem('regimenCliente', selectedOption.target.value)
        
    };

    //handle Tipo Doc
    const handleTipoDocumento = (selectedOption) => {
        localStorage.setItem('tipoDocCliente', selectedOption.target.value)
        
    };

    //handle NUm Doc CLiente
    const handleNumDocCliente = (selectedOption) => {
        localStorage.setItem('numDocCliente', selectedOption.target.value);
        
    };

    //handle dv cliente
    const handleDV = (selectedOption) => {
        localStorage.setItem('dvCliente', selectedOption.target.value);
        
    };

    //handle direccionCliente
    const handleAdress = (selectedOption) => {
        localStorage.setItem('direccionCliente', selectedOption.target.value);
        
    };

    //handle Pais 
    const handlePais = (selectedOption) => {
        selectDataDepartamentosLoad(selectedOption.target.value);
        localStorage.setItem('pais', selectedOption.target.value)
        
    };

    //handle Departamento/Estado 
    const handleEstado = (selectedOption) => {
        selectDataCiudadesLoad(selectedOption.target.value);
        localStorage.setItem('estado', selectedOption.target.value);
        
    };

    //handle ciudad 
    const handleCiudad = (selectedOption) => {
        localStorage.setItem('ciudad', selectedOption.target.value)
        
    };

    //handle telefono Cliente
    const handlePhone = (selectedOption) => {
        localStorage.setItem('telefonoCliente', selectedOption.target.value);
        
    };

    //handle codigo ZIP
    const handleZip = (selectedOption) => {
        localStorage.setItem('zipCliente', selectedOption.target.value);
        
    };

    //handle correo Cliente
    const handleCorreo = (selectedOption) => {
        localStorage.setItem('correoCliente', selectedOption.target.value);
        
    };

    const handlenitbusqueda = (selectedOption) => {
        localStorage.setItem('nitBusqueda', selectedOption.target.value);
        setnitbusqueda(selectedOption.target.value);
    };

    

  return (
    <React.Fragment>
          <h5 style={{ textAlign: "center", fontSize: "20px" }}>Datos Generales</h5>
          <Grid container spacing={3} style={{ marginTop: "20px" }}>


              <Grid item xs={12} sm={4}>
                  <TextField
                      required
                      id="Nitbusqueda"
                      name="Nitbusqueda"
                      label="Buscar cliente por NIT"
                      fullWidth
                      autoComplete="given-name"
                      value={nitbusqueda}
                      onChange={handlenitbusqueda} 
                  ></TextField>
              </Grid>
              <Grid item xs={12} md={2}>
                  <Button
                      variant="contained"
                      color="secondary"
                      style={{ margin: "5px" }}
                      onClick={selectDataClienteFindLoad}
                      disabled={false}
                  >Buscar Cliente
                   </Button>
              </Grid>
              <Grid item xs={12} md={6}>
                  <Collapse in={alertaInfo} style={{ marginTop: "-10px" }}>
                      <Alert severity="info" onClose={() => { setalertaInfo(false); }}>
                      <AlertTitle>Información</AlertTitle>
                   Si quieres un cliente diferente, Busca un cliente por <strong>nit</strong>.
                </Alert>
                  </Collapse>
                  <Collapse in={alertaError} >
                      <Alert severity="error" onClose={() => { setalertaError(false); }}>
                          <AlertTitle>Error</AlertTitle>
                   no se encontro ningun cliente con el NIT <strong>nit</strong>.
                </Alert>
                  </Collapse>
                  <Collapse in={alertaSuccess} >
                      <Alert severity="success" onClose={() => { setalertaSuccess(false); }}>
                          <AlertTitle>Cliente encontrado</AlertTitle>
                   Se establecio un nuevo cliente para la <strong>factura</strong>.
                </Alert>
                  </Collapse>
              </Grid>

        <Grid item xs={12} sm={4}>
          <TextField
                      required
                      id="Name"
                      name="Name"
                      label="Nombre del Cliente"
                      fullWidth
                      autoComplete="given-name"
                      value={nombreCliente}
                      onChange={handleNombreCliente} disabled
                  ></TextField>
              </Grid>
        <Grid item xs={12} sm={4}>
                  <FormControl variant="outlined" fullWidth>
                      <InputLabel required fullWidth >Persona</InputLabel>
                      <Select
                          labelId="demo-simple-select-required-label"
                          id="demo-simple-select-required"
                          fullWidth
                          label="Tipo Doc."
                          value={tipoPersonaData}
                          onChange={handleTipoPersona} disabled>
                          {dataTiposPersonas.map((tipo, index) =>
                              <MenuItem key={index} value={tipo.Codigo}>{tipo.Descripcion}</MenuItem>)}
                      </Select>
                  </FormControl>
              </Grid>
        <Grid item xs={12} sm={4}>
                  <FormControl variant="outlined" fullWidth>
                      <InputLabel required fullWidth>Regimen</InputLabel>
                      <Select
                          labelId="demo-simple-select-required-label"
                          id="demo-simple-select-required"
                          fullWidth
                          label="Regimen de Facturación"
                          value={regimendata}
                          onChange={handleRegimen} disabled>
                          {dataTipoRegimen.map((tipo, index) =>
                              <MenuItem key={index} value={tipo.Codigo}>{tipo.Descripcion}</MenuItem>)}
                      </Select>
                  </FormControl>
              </Grid>
        <Grid item xs={12} sm={4}>
                  <FormControl variant="outlined" fullWidth>
                      <InputLabel required fullWidth>Tipo Doc.</InputLabel>
                      <Select
                          labelId="demo-simple-select-required-label"
                          id="demo-simple-select-required"
                          fullWidth
                          label="Tipo Doc."
                          value={identidad}
                          onChange={handleTipoDocumento} disabled>

                          {dataTiposIdentificacionPersonas.map((tipo, index) =>
                              <MenuItem key={index} value={tipo.Codigo}>{tipo.Descripcion}</MenuItem>)}
                      </Select>
                  </FormControl>
              </Grid>
        <Grid item xs={12} sm={4}>
          <TextField
                      required
                      id="company"
                      name="company"
                      label="Documento del Cliente"
                      fullWidth
                      autoComplete="family-name"
                      value={nitcliente}
                      onChange={handleNumDocCliente} disabled
          />
              </Grid>
        <Grid item xs={12} sm={4}>
                  <TextField
                      required
                      id="company"
                      name="company"
                      label="Digito Verificación"
                      fullWidth
                      value={dvcliente}
                      onChange={handleDV} disabled
                  />
              </Grid>
        <Grid item xs={12}>
          <TextField
                      required
                      id="direccion"
                      name="direccion"
                      label="Dirección"
                      fullWidth
                      autoComplete="shipping address-line1"
                      value={direccioncliente}
                      onChange={handleAdress} disabled
          />
        </Grid>
        <Grid item xs={12} sm={6}>
        <FormControl variant="outlined" fullWidth>
        <InputLabel required fullWidth>País</InputLabel>
        <Select
                          labelId="demo-simple-select-required-label"
                          id="demo-simple-select-required"
                          fullWidth
                          label="Tipo de Comprobante"
                          value={paiscliente}
                          onChange={handlePais} disabled>
                          {dataPaisesLista.map((tipo, index) =>
                              <MenuItem key={index} value={tipo.Codigo}>{tipo.Descripcion}</MenuItem>)}
          </Select>
          </FormControl>
        
        </Grid>
        <Grid item xs={12} sm={6}>
        <FormControl variant="outlined" fullWidth>
        <InputLabel required fullWidth>Estado </InputLabel>
        <Select
                          labelId="demo-simple-select-required-label"
                          id="demo-simple-select-required"
                          fullWidth
                          label="Estado"
                          value={estadocliente}
                          onChange={handleEstado} disabled>

                          {dataDepartamentosLista.map((tipo, index) =>
                              <MenuItem key={index} value={tipo.Codigo}>{tipo.Descripcion}</MenuItem>)}
          </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={6}>
        <FormControl variant="outlined" fullWidth>
        <InputLabel required fullWidth>Ciudad</InputLabel>
        <Select
                          labelId="demo-simple-select-required-label"
                          id="demo-simple-select-required"
                          fullWidth
                          label="Tipo de Comprobante"
                          value={ciudadcliente}
                          onChange={handleCiudad} disabled>

                          {dataCiudadLista.map((tipo, index) =>
                              <MenuItem key={index} value={tipo.Codigo}>{tipo.Descripcion}</MenuItem>)}
          </Select>
          </FormControl>
          
        </Grid>
        <Grid item xs={12} sm={6}>
        <TextField
                      required
                      id="zip"
                      name="zip"
                      label="Teléfono"
                      type="number"
                      fullWidth
                      autoComplete="shipping postal-code"
                      value={telefonocliente}
                      onChange={handlePhone} disabled
          />
        </Grid>
        <Grid item xs={12} sm={6}>
        <TextField
                      required
                      id="zip"
                      name="zip"
                      label="Codigo Postal"
                      type="number"
                      fullWidth
                      autoComplete="shipping postal-code"
                      value={zipcliente}
                      onChange={handleZip} disabled
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
                      required
                      id="country"
                      name="country"
                      label="Correo"
                      type="email"
                      fullWidth
                      autoComplete="shipping country"
                      value={correocliente}
                      onChange={handleCorreo} disabled
          />
        </Grid>
              <Grid item xs={12} sm={6} >
                  {loading && <Spinner color="secondary" />}
              </Grid>
      </Grid>
    </React.Fragment>
  );
}
